import get from "lodash/get";
import filter from "lodash/filter";
import isEmpty from "lodash/isEmpty";
import sortBy from "lodash/sortBy";
import head from "lodash/head";

export const AudienceBucketSizes = ["0-100", "100-1000", "1000-5000", "5000-20000", "20000+"];

function isValidAudienceBucketSize(show) {
  const bucketedAudienceSize = get(show, "bucketedAudienceSize");
  return AudienceBucketSizes.indexOf(bucketedAudienceSize) !== -1;
}

function getAdjacentAudienceBucketSizes(show) {
  const bucketedAudienceSize = get(show, "bucketedAudienceSize");
  const index = AudienceBucketSizes.indexOf(bucketedAudienceSize);
  if (index === -1) {
    return ["calculating", ""];
  }
  if (0 < index && index < AudienceBucketSizes.length - 1) {
    return [AudienceBucketSizes[index - 1], AudienceBucketSizes[index + 1]];
  } else if (0 < index) {
    return [AudienceBucketSizes[index - 1]];
  } else {
    return [AudienceBucketSizes[index + 1], "calculating", ""];
  }
}

export function getAllAdjacentAudienceBucketSizes(shows = []) {
  let bucketedAudienceSizeSet = new Set();
  if (shows && shows.length > 0) {
    shows.forEach(show => {
      if (isValidAudienceBucketSize(show)) {
        const sizes = getAdjacentAudienceBucketSizes(show);
        sizes.forEach(size => {
          bucketedAudienceSizeSet.add(size);
        });
        bucketedAudienceSizeSet.add(show.bucketedAudienceSize);
      }
    });
  }

  // If no bucketedAudienceSizes are found, default to "", calculating
  if (bucketedAudienceSizeSet.size === 0) {
    bucketedAudienceSizeSet.add("");
    bucketedAudienceSizeSet.add("calculating");
    bucketedAudienceSizeSet.add("0-100");
  }
  return Array.from(bucketedAudienceSizeSet);
}

// returns array of all shows a user owns
export function getUserShows(user, shows = {}) {
  const userUUID = get(user, "uuid", undefined);
  return filter(shows, show => {
    const showUserUUID = get(show, "userUUID");
    return userUUID === showUserUUID;
  });
}

export function isShowEligibleForCrossPromo(show = {}) {
  const canShareAudienceSize = get(show, "canShareAudienceSize", false);
  const isVisible = get(show, "isVisible", false);
  const redirectAwayURL = get(show, "redirectAwayURL", "");
  const redirectVerified = get(show, "redirectVerified", false);
  const importedURL = get(show, "importedURL", "");

  if (!isEmpty(importedURL) && redirectVerified === false) return false;
  if (!isEmpty(redirectAwayURL)) return false;
  if (!isVisible) return false;
  return canShareAudienceSize;
}

export function getBiggestShow(shows = []) {
  const sortedShows = sortBy(shows, show => {
    const bucketSize = get(show, "bucketedAudienceSize", "");
    const index = AudienceBucketSizes.indexOf(bucketSize);
    return index;
  });
  if (!sortedShows.length) return {};
  return head(sortedShows);
}
